<div class="account">
  <div class="l_max-screen">
    <div class="l_body-wrap">
      <div class="login full-height">
        <div class="grid grid--full-width full-height">
          <div class="no-mobile grid__col-6 account__photo"></div>
          <div class="grid__col-auto center-text grid--align-self-center">
            <a href="/" class="ib rel guts-m-b-1" data-dgat="logged-out-a40">
              <img
                [src]="degreedGlassesLogo"
                static="true"
                alt="Degreed"
                width="37"
                height="24"
                role="img"
              />
            </a>
            <h1
              class="color-blue account__title rel guts-p-b-2 guts-m-b-5"
              [textContent]="headerText"
            ></h1>
            <div class="account__wrapper">
              <a
                df-button
                dfButtonType="primary"
                [href]="loginUrl"
                class="full-width"
                 data-dgat="logged-out-fc6">{{ buttonLabel }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
